import { render, staticRenderFns } from "./profile_disconect.vue?vue&type=template&id=2d200c72&"
import script from "./profile_disconect.vue?vue&type=script&lang=js&"
export * from "./profile_disconect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports